const defaultOptions = {
  queries: {
    refetchOnWindowFocus: true,
    refetchOnMount: true,

    // Refetch on network reconnection
    refetchOnReconnect: true,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    staleTime: 2 * 60 * 1000, // 2 minutes

    gcTime: 5 * 60 * 1000, // 5 minutes
    placeholderData: (previousData) => previousData,
  },
  mutations: {
    // Retry mutations once on failure
    retry: 1,
    retryDelay: 1000,
  },
};

// Export specific cache time constants for custom hooks
export const CACHE_TIMES = {
  SHORT: 1 * 60 * 1000, // 1 minute - for frequently changing data
  MEDIUM: 5 * 60 * 1000, // 5 minutes - for moderately stable data
  LONG: 15 * 60 * 1000, // 15 minutes - for rarely changing data
  VERY_LONG: 60 * 60 * 1000, // 1 hour - for static data
};

export default defaultOptions;
